var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40586"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40577"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47293",
    d: "M-924.361 279.242c.205-.932.334-1.889.63-2.791a14.547 14.547 0 0 1 6.319-7.8 18.49 18.49 0 0 1 8.694-2.9c.488-.037.62-.208.678-.688a13.446 13.446 0 0 1 4.141-8.189 16.92 16.92 0 0 1 10.776-4.8 18.551 18.551 0 0 1 13.351 4.018 13.433 13.433 0 0 1 5.085 7.815 12.58 12.58 0 0 1-2.692 11.066 4.17 4.17 0 0 0-.729 4.029 5.327 5.327 0 0 0 1.345 2.4 1.059 1.059 0 0 1 .339 1.267 1.09 1.09 0 0 1-1.188.568 10.9 10.9 0 0 1-6.878-2.748.684.684 0 0 0-.532-.168 23.393 23.393 0 0 1-5.173.918c-.128.009-.255.037-.372.054-.15.784-.244 1.56-.449 2.307a14.615 14.615 0 0 1-7.364 9.109 18.35 18.35 0 0 1-12.037 1.993c-1.088-.165-2.159-.453-3.228-.725a.61.61 0 0 0-.635.195 10.754 10.754 0 0 1-6.928 2.735 1.037 1.037 0 0 1-1.117-.6 1.028 1.028 0 0 1 .311-1.188 5.812 5.812 0 0 0 1.544-4.988 1.489 1.489 0 0 0-.323-.731 13.759 13.759 0 0 1-3.487-7.689 2.431 2.431 0 0 0-.083-.325zm5.057 15.43c.144-.028.206-.035.266-.052a8.649 8.649 0 0 0 3.96-2.388 1.094 1.094 0 0 1 1.269-.355 18.441 18.441 0 0 0 5.431 1.087 15.6 15.6 0 0 0 11.908-4.012 11.423 11.423 0 0 0 .285-17.017 14.938 14.938 0 0 0-9.615-4.235 16.218 16.218 0 0 0-12.952 4.5 10.953 10.953 0 0 0-3.642 8.382 11.379 11.379 0 0 0 3.138 7.58 2.644 2.644 0 0 1 .667 1.318 8.078 8.078 0 0 1-.711 5.192zm13.163-29c.191.031.318.062.447.071a18.116 18.116 0 0 1 6.552 1.752 1.7 1.7 0 0 0 .7.124q7.419.01 14.838.005c.163 0 .326-.009.488.006a.977.977 0 0 1 .925.955.98.98 0 0 1-.944.986c-.146.011-.293.005-.439.005h-12.31a14.167 14.167 0 0 1 5.268 9.7 1.23 1.23 0 0 0 .2.027 19.13 19.13 0 0 0 5.386-1.06 1.164 1.164 0 0 1 1.367.311 10.485 10.485 0 0 0 1.249 1.086 7.938 7.938 0 0 0 2.972 1.368l-.138-.332c-.038-.089-.089-.175-.119-.267-.777-2.352-1.046-4.534.81-6.685a10.378 10.378 0 0 0 2.357-9.034 11.509 11.509 0 0 0-4.422-7.033 16.487 16.487 0 0 0-15.591-2.922 13.605 13.605 0 0 0-8.088 6.207 10.66 10.66 0 0 0-1.508 4.729z",
    transform: "translate(924.361 -249.016)",
    style: {
      fill: "#9ee67a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47294",
    d: "M-906.166 290.518h-7.7a3.7 3.7 0 0 1-.487-.012.978.978 0 0 1-.858-.967.977.977 0 0 1 .863-.962 3.4 3.4 0 0 1 .438-.011h15.555a3.4 3.4 0 0 1 .438.011.979.979 0 0 1 .858.967.978.978 0 0 1-.863.963 3.851 3.851 0 0 1-.487.011z",
    transform: "translate(923.03 -254.337)",
    style: {
      fill: "#9ee67a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47295",
    d: "M-903.5 283.662c-1.982 0-3.965.01-5.947-.012a1.218 1.218 0 0 1-.836-.267 1.432 1.432 0 0 1-.29-.954.832.832 0 0 1 .772-.7 2.5 2.5 0 0 1 .438-.015H-897.419a.988.988 0 0 1 1.037.992.976.976 0 0 1-1.024.955c-.812.014-1.624 0-2.437 0z",
    transform: "translate(922.355 -253.339)",
    style: {
      fill: "#9ee67a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47296",
    d: "M-913.27 282.679a.986.986 0 0 1-.99.981.984.984 0 0 1-.955-.966.981.981 0 0 1 .989-.979.983.983 0 0 1 .956.964z",
    transform: "translate(923.029 -253.339)",
    style: {
      fill: "#9ee67a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47297",
    d: "M-884.556 263.426c1.982 0 3.964-.01 5.947.012a1.22 1.22 0 0 1 .836.269 1.434 1.434 0 0 1 .286.954.833.833 0 0 1-.773.7 2.484 2.484 0 0 1-.437.015H-890.641a.986.986 0 0 1-1.034-1 .974.974 0 0 1 1.025-.952c.91-.013 1.82 0 2.73 0z",
    transform: "translate(919.603 -250.677)",
    style: {
      fill: "#9ee67a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47298",
    d: "M-894.3 264.38a.983.983 0 0 1-.974 1 .984.984 0 0 1-.971-.95.982.982 0 0 1 .974-1 .984.984 0 0 1 .971.95z",
    transform: "translate(920.268 -250.678)",
    style: {
      fill: "#9ee67a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3446",
    style: {
      fill: "none"
    },
    d: "M0 0h50v50H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/Communication.05bed62a4be066fc021d0da892f75fd8.svg";
export { ForwardRef as ReactComponent };